import ShipmentPointsGroup from '@/dto/deliveries/ShipmentPointsGroup'

// «1 страна = 1 город»: если у страны единственная точка отправки, показываем
// название страны вместо города — так выбор нагляднее и в панели, и в калькуляторе.
// Russia (много точек) остаётся с городами.
export function isSingleCountry(group: ShipmentPointsGroup): boolean {
  return group.points.length === 1
}

// countryId стран с единственной точкой отправки (для поиска по точке без группы).
export function singleCountryIds(groups: ShipmentPointsGroup[]): Set<number> {
  return new Set(groups.filter(isSingleCountry).map(group => group.countryId))
}
